import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { Typography } from "@mui/material";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { resourceCreatedByColumnDef } from "../common/resourceCreatedByColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { getResourceSizeColumnDef } from "../common/getResourceSizeColumnDef";
import {
  DynamoDbBackupType,
  FilteredDynamoDbBackupResourceItem,
} from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const dynamoDbBackupColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef(),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("dynamo_db_backup"),

  resourceAccountColumnDef,

  getResourceCreationTimeColumnDef("Date Created"),

  resourceTotalSpendColumnDef,

  { field: "resource.table_name", headerName: "Table" },

  getResourceSizeColumnDef(),

  {
    field: "resource.type",
    headerName: "Type",
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredDynamoDbBackupResourceItem>) => {
      const type = data?.resource?.type;

      const labels: Record<DynamoDbBackupType, string> = {
        aws_backup: "AWS Backup",
        user: "User",
        system: "System",
      };

      if (!type) {
        return "N/A";
      }

      return <Typography variant="body2">{labels?.[type]}</Typography>;
    },
  },

  { field: "resource.storage_tier", headerName: "Storage Tier" },

  resourceCreatedByColumnDef,

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
